import React from 'react';
import clsx from 'clsx';
import { Modal } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import ErrorHeader from '../errors/ErrorHeader';
import DialogHeaderMessage from './DialogHeaderMessage';

const DialogWrapper = ({
  children,
  className,
  copyText,
  error,
  icon,
  loading,
  message,
  messageError,
  messageIcon = 'info',
  onClose,
  onDismiss,
  size = 'tiny',
  theme,
  title,
  values,
  warning,
}) => (
  <Modal
    className={clsx('aridhia-dialog-wrapper', className, `aridhia-theme-${theme}`)}
    open
    onClose={onClose}
    size={size}
    closeOnDimmerClick={false}
  >
    <ErrorHeader icon={icon} title={title} error={error} onDismiss={onDismiss} />
    {hasMinimumLength(message) && (
    <DialogHeaderMessage
      className={className}
      copyText={copyText}
      error={messageError}
      icon={messageIcon}
      loading={loading}
      message={message}
      values={values}
      warning={warning}
    />
    )}
    {children}
  </Modal>
);

export default DialogWrapper;
